<template>
  <div class="pg-company-list">
      <header>
          <div class="search-wrapper">
              <input type="text" placeholder="请输入产品名称/CAS/牌号/生产商名称" @keyup.enter="search" v-model="keywords"/>
          </div>
          <button @click="search">搜索</button>
      </header>
      <div class="list" id="list">
          <ul>
              <li v-for="item in companyList" :key="item.companyId"><router-link :to="{name:'company',query:{id:item.companyId}}">
                  <div class="img-wrapper">
                      <img :src="item.logo" alt="" v-if="item.logo">
                      <img src="../../assets/images/company-default.png" alt="" v-else>
                  </div>
                  <div class="item-right">
                      <h3>{{item.companyName}}</h3>
                      <p><em>{{item.numbers}}</em>种化学产品</p>
                  </div>
                  </router-link>
              </li>
              <li class="nomore">{{loadTips}}</li>
          </ul>
      </div>
      <div class="ctrls">
          <router-link to="/"><span><img src="../../assets/images/home.png" alt="返回首页"></span></router-link>
          <transition name="fade">
          <span v-show="backTopShow"><img src="../../assets/images/top.png" alt="回到顶部" @click="scroolTop"></span>
          </transition>
      </div>
  </div>
</template>
<script>
import config from '../../common/config'
import {Loading,Message} from 'element-ui';
import axios from 'axios';
import Jroll from 'jroll'

export default {
    name:'companylist',
  data(){
      return {
          keywords: '',
          backTopShow:false,
          companyInfo:"",
          companyList:[],
          page:1,
          loadTips:"加载中...",
          loading:false
      }
  },
  mounted () {
    _hmt.push(['_trackPageview', `/${window.location.hash}`]);
     window.addEventListener('scroll', this.handleScroll);
     this.getData()

  },
  updated () {

  },
  destroyed () {
      window.removeEventListener('scroll', this.handleScroll);
    },
  methods: {
      handleScroll(){
          if(document.body.scrollTop > 100||document.documentElement.scrollTop > 100){
              this.backTopShow=true;
          }else{
              this.backTopShow=false;
          }
          if(this.loading) return;
          if (document.body.scrollHeight - document.body.scrollTop - window.innerHeight < 150||document.body.scrollHeight - document.documentElement.scrollTop - window.innerHeight < 150) {
              this.loadmore()
          }
      },
      scroolTop(){
        window.scrollTo(0, 0);
      },
      getData(page){
          let url = 'api/web/index.php?r=company/company-list&page=1&keyName=' + this.keywords;
          if (page) {
              url = 'api/web/index.php?r=company/company-list&page='+page + '&keyName=' + this.keywords;
          }
        axios.get(config.PHPHOST+url).then(
            res => {
                if (res.data.flag == 0) {
                    this.companyInfo = {
                        page:res.data.data.page,
                        pageNum:Math.ceil(res.data.data.pageNum),
                        pageSize:res.data.data.pageSize,
                        totalNum:res.data.data.totalNum,
                    };
                    this.companyList.push.apply(this.companyList,res.data.data.list);
                    this.loading = false;
                    if (this.page+1>=this.companyInfo.pageNum) {
                        this.loadTips='没有更多数据了';
                    }
                }else{
                    this.loadTips='没有更多数据了';
                    Message({
                        message:res.data.msg,
                        showClose:false,
                        customClass:'search-msg-style',
                        duration:2000
                    });
                }
            },
            err => {
                    Message({
                        message:err,
                        showClose:false,
                        customClass:'search-msg-style',
                        duration:2000
                    });
            }
        )
      },
      loadmore(){
          this.loading = true;
          if (this.companyInfo.pageNum>this.page+1) {
              this.page++;
              this.getData(this.page)
          }else{
              return false;
          }
      },
      search() {
          this.backTopShow = false;
          this.companyInfo = "";
          this.companyList = [];
          this.page = 1;
          this.loadTips = "加载中...";
          this.loading = false;
          this.getData();
      }
  }
}
</script>
<style lang="less">
.fade-enter-active, .fade-leave-active {
  transition: opacity .5s
}
.fade-enter, .fade-leave-to  {
  opacity: 0
}
    .pg-company-list {
        header {
            display: flex;
            height: 4rem;
            line-height: 4rem;
            background-color: #f5f5f5;
            border-bottom: 1rem solid #f5f5f5;
            position: fixed;
            width: 100%;
            left: 0;
            top: 0;
            z-index: 9;
            .search-wrapper {
                flex:1;
                display: flex;
                padding-left: 1rem;
                padding-right: 1rem;
                padding-top: 1rem;
                input {
                    height: 2.6rem;
                    border:none;
                    border-radius: 1.4rem;
                    flex:1;
                    outline: none;
                    padding-left: 3rem;
                    padding-right: 1rem;
                    background:  #fff url(../../assets/images/search-icon.png) 1rem  no-repeat;
                    background-size: 1.6rem;
                }
            }
            button {
                flex:none;
                width: 4rem;
                line-height: 4.8rem;
                text-align: center;
                font-size: 1.6rem;
                color: #0994ff;
                outline: none;
                border:none;
                background-color: #f5f5f5;;
            }

            
        }
        .list {
            padding-top: 5rem;
            ul {
                li {
                    a {
                        border-bottom: .1rem solid #e1e1e1;
                    width: 100%;
                    overflow: hidden;
                    text-overflow: ellipsis;
                    white-space: nowrap;
                    display: flex;
                    }
                    
                    .img-wrapper {
                        flex:none;
                        width: 4rem;
                        height: 4rem;
                        border:.1rem solid #ddd;
                        border-radius: 4rem;
                        margin: 1rem;
                        overflow: hidden;
                        img {
                            width: 100%;
                            height: 100%;
                            display: block;
                        }
                     
                    }
                    .item-right {
                        flex:1;
                        padding-right: 3rem;
                        position: relative;
                        white-space:nowrap;
                        overflow:hidden;
                        text-overflow:ellipsis;
                        &::after {
                            content: '';
                            position: absolute;
                            width: 2rem;
                            height: 100%;
                            right: 0;
                            top: 0;
                            background:url(../../assets/images/arrow-r.png) center no-repeat;
                            background-size: .6rem;
                        }
                        h3 {
                            width: 100%;
                            font-size: 1.5rem;
                            margin-top: 1rem;
                            line-height: 3rem;
                            font-weight: 400;
                            overflow: hidden;
                            text-overflow: ellipsis;
                            
                        }
                        p {
                            line-height: 2rem;
                            color: #666;
                            font-size: 1.3rem;
                            em {
                                color: #0994ff;
                            }
                        }
                    }
                }
            }
        }
        .ctrls {
            position: fixed;
            width: 3rem;
            height: 7rem;
            bottom: 6rem;
            right: 1rem;
            span {
                display: block;
                width: 3rem;
                height: 3rem;
                margin-bottom: 1rem;
                img {
                    width: 100%;
                    height: 100%;
                }
            }
        }
    }
</style>




// WEBPACK FOOTER //
// src/components/home/company-list.vue